import { Experiment } from "@amplitude/experiment-js-client";
import type { UserId } from "@common/types/user";
export function makeFeatureFlagService() {
  const experiment = Experiment.initializeWithAmplitudeAnalytics(
    process.env.NEXT_PUBLIC_AMPLITUDE_EXPERIMENT_DEPLOYMENT!
  );

  const featureFlagService = {
    initialize: async ({ userId }: { userId: UserId }) => {
      if (featureFlagService.isTest) return;
      try {
        await experiment.start({ user_id: userId });
      } catch (error) {
        console.error("Failed to start experiment - likely adblock");
      }
    },
    getFeatureEnabled: (flagKey: string, comparisonValue = "on") => {
      if (featureFlagService.isTest) return true;
      const variant = experiment.variant(flagKey);
      return variant.value === comparisonValue;
    },
    isTest: false,
    setIsTest: () => {
      featureFlagService.isTest = true;
    },
  };

  return featureFlagService;
}

export type FeatureFlagService = ReturnType<typeof makeFeatureFlagService>;
